import DispensaryProductPage from 'src/dispensary/product';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(DispensaryProductPage, CoreMenuLayout);
